import React, { Fragment, useEffect, useState } from "react";
import { navigation } from "../navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { raise_api_call_menu } from "../redux/login-and-create-password/menu-reducer";
import { configs } from "../common";
import { clear_single_partner_details } from "../redux/business-partner/partner-master/list-one-partner-details";
import ProfileImg from "../assets/images/profile.svg";
import LogoutImg from "../assets/images/logout.svg";
import { useCommonContext } from "../Utils/commonContext";
import { Box, Collapse, styled } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

type Props = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const SideNav: React.FC<Props> = ({ isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const { open, setOpen, isMobile } = useCommonContext();

  // getting the menu list from the store and assigned to menus
  const menus = useSelector((state: any) => state.Menus);
  useEffect(() => {
    dispatch(raise_api_call_menu(""));
  }, []);
  return (
    <div className="border-box  sidenav_container  m-0">
      <Fragment>
        {!isMobile && !open ? (
          <img width={78} src={require("../assets/images/SPRVL-Black 3.png")} />
        ) : (
          <div className="log_container">
            <img src={require("../assets/images/SPRVL-Black 1.png")}></img>
            <img src={require("../assets/images/SPRVL-Black 2.png")} />
          </div>
        )}
      </Fragment>
      <div className="sidenav_menus">
        {menus.data.length != 0
          ? menus.data.result.map((e: object, key: number) => {
              return <Submenus e={e} key={key} />;
            })
          : ""}
      </div>
      <div className="sidenav_footer">
        <div className="d-flex ps-2 pe-3 py-2  pointer menu-text">
          <div className="d-flex">
            <div className="d-flex mx-2 align-items-center fs-5">
              <img
                src={ProfileImg}
                style={{
                  width: "30px",
                  maxHeight: "20px",
                }}
                className="menu-icon"
              />
            </div>

            <div typeof="button" className="text-start menu-text">
              {localStorage.getItem("userName")}
            </div>
          </div>
        </div>
        <div className="d-flex ps-2 pe-3 py-2  pointer menu-text">
          <div className="d-flex">
            <div className="d-flex mx-2 align-items-center fs-5">
              <img
                src={LogoutImg}
                style={{
                  width: "30px",
                  maxHeight: "20px",
                }}
                className="menu-icon"
                onClick={() => {
                  localStorage.removeItem("SpApperalsToken");
                  localStorage.removeItem("SpApperalsRole");
                  localStorage.removeItem("SpToken");
                  window.location.pathname = "/login";
                  // navigate("/login");
                }}
              />
            </div>

            <div typeof="button" className="text-start menu-text">
              Logout
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// creating sub-menus
const Submenus = (props: any) => {
  const dispatch = useDispatch();
  const { e, key } = props;
  const navigate = useNavigate();
  const { open, setOpen, isMobile } = useCommonContext();
  const locationPath = window.location.pathname.split("/");
  const [subnav, setSubnav] = useState<Boolean>(
    locationPath[1] === e.path.split("/")[1] ? true : false
  );
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const popoverOpen = Boolean(anchorEl);

  return (
    <div>
      <div
        className="d-flex ps-2 pe-3 py-3  pointer menu-text"
        id={
          locationPath[1] === e.path.split("/")[1]
            ? "activesidenav"
            : "notActivesidenav"
        }
        onClick={() => {
          setSubnav(!subnav);
          if (e.children.length === 0) {
            navigate(e.path);
          }
        }}
      >
        <Tooltip
          placement="right"
          arrow
          title={
            !isMobile && !open && e.children.length > 0 ? (
              <div className="bg-white">
                {e.children.map((a: any, key: number) => (
                  <div className="d-flex bg-white">
                    <div
                      className="mx-2 p-2 float-end pointer d-flex "
                      key={key}
                      onClick={() => {
                        dispatch(clear_single_partner_details(""));
                        navigate(a.path);
                      }}
                    >
                      <div
                        id={
                          locationPath[1] + "/" + locationPath[2] ===
                          a.path.split("/")[1] + "/" + a.path.split("/")[2]
                            ? "activesubnav"
                            : "notactivesubnav"
                        }
                        className="ms-auto text-start d-flex align-items-center gap-2"
                      >
                        <Fragment>
                          <div className="sub-menu-icon"></div>
                          <span className="menu-text">{a.menu}</span>
                        </Fragment>
                      </div>
                    </div>
                    {a.icon ? (
                      <div
                        id={
                          locationPath[1] + "/" + locationPath[2] ===
                          a.path.split("/")[1] + "/" + a.path.split("/")[2]
                            ? "iconactive"
                            : "notactivesubnav"
                        }
                        className="ms-auto d-flex mx-3 px-2 align-items-center"
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          a.menu === "Onboarding" ? (
                            navigate("/business-partner/onboarding/add")
                          ) : (
                            <div></div>
                          );
                        }}
                      >
                        <img
                          src={"http://185.209.228.65:3035" + e.icon}
                          style={{
                            color: "white",
                            width: "30px",
                            filter: "brightness(0) invert(1)",
                          }}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ))}
              </div>
            ) : (
              ""
            )
          }
        >
          <div className="d-flex">
            <div className="d-flex mx-2 align-items-center fs-5">
              <img
                src={configs.api + e.icon}
                style={{
                  width: "30px",
                  maxHeight: "20px",
                }}
                className="menu-icon"
              />
            </div>

            {(isMobile || open) && (
              <div key={key} typeof="button" className="text-start menu-text">
                {e.menu}
              </div>
            )}
          </div>
        </Tooltip>

        {(isMobile || open) && (
          <div className=" align-items-center float-end me-0 d-flex ms-auto justify-content-end">
            {e.children.length != 0 ? (
              subnav ? (
                <FontAwesomeIcon
                  className="float-end fs-7"
                  icon={["fas", "caret-up"]}
                />
              ) : (
                <FontAwesomeIcon
                  className="float-end fs-7"
                  icon={["fas", "caret-down"]}
                />
              )
            ) : (
              ""
            )}
          </div>
        )}
      </div>
      {subnav && e.children ? (
        <Collapse in={isMobile || open} timeout="auto" unmountOnExit>
          {e.children.map((a: any, key: number) => {
            return (
              <div className="d-flex">
                <div
                  className="mx-3 float-end ps-3 pointer d-flex "
                  key={key}
                  onClick={() => {
                    dispatch(clear_single_partner_details(""));
                    navigate(a.path);
                  }}
                >
                  <div
                    id={
                      locationPath[1] + "/" + locationPath[2] ===
                      a.path.split("/")[1] + "/" + a.path.split("/")[2]
                        ? "activesubnav"
                        : "notactivesubnav"
                    }
                    className="py-3 ps-3 ms-auto text-start d-flex align-items-center gap-2"
                  >
                    {(isMobile || open) && (
                      <Fragment>
                        <div className="sub-menu-icon"></div>
                        <span className="menu-text">{a.menu}</span>
                      </Fragment>
                    )}
                  </div>
                </div>
                {a.icon ? (
                  <div
                    id={
                      locationPath[1] + "/" + locationPath[2] ===
                      a.path.split("/")[1] + "/" + a.path.split("/")[2]
                        ? "iconactive"
                        : "notactivesubnav"
                    }
                    className="ms-auto d-flex mx-3 px-2 align-items-center"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      a.menu === "Onboarding" ? (
                        navigate("/business-partner/onboarding/add")
                      ) : (
                        <div></div>
                      );
                    }}
                  >
                    <img
                      src={"http://185.209.228.65:3035" + e.icon}
                      style={{
                        color: "white",
                        width: "30px",
                        filter: "brightness(0) invert(1)",
                      }}
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          })}
        </Collapse>
      ) : (
        ""
      )}
    </div>
  );
};
export default SideNav;
